var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "v-card",
    { staticClass: "box-affiliations" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                {
                  staticClass: "align-items",
                  attrs: { row: "", "justify-center": "", xs2: "", sm1: "" }
                },
                [
                  _c("v-icon", { class: _vm.props.icon }),
                  _c("v-icon", { class: _vm.props.iconTwo })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs10: "", sm11: "" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "py-0 pl-4 pr-0" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "px-0 title", attrs: { xs12: "" } },
                        [
                          _c("h1", { staticClass: "d-inline-block" }, [
                            _vm._v(_vm._s(_vm.props.num))
                          ]),
                          _c("p", { staticClass: "d-inline-block" }, [
                            _vm._v(_vm._s(_vm.props.title))
                          ])
                        ]
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "mx-1 subtitle", attrs: { xs12: "" } },
                        [
                          _c("span", { staticClass: "d-inline-block" }, [
                            _vm._v(_vm._s(_vm.props.subNum))
                          ]),
                          _c("h5", { staticClass: "ml-1 d-inline-block" }, [
                            _vm._v(_vm._s(_vm.props.subtitle))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._t("default")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5419b162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5419b162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/box-afiliations.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5419b162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/box-afiliations.vue
// module chunks = 5